export default {"src":"/_next/static/media/laptop.d23f7378.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};